import Lum from 'luminate/src/lum'

import Links from './components/links'
import Scroll from './components/scroll'
import Image from './components/image'
import Autosize from './components/autosize'

export default function(context = document.body)
{
	Links(context)
	Scroll(context)
	Image(context)
	Autosize(context)

	Lum.start(context)
}



// WEBPACK FOOTER //
// ./source/scripts/init.js